import { render, staticRenderFns } from "./Convocatorias.vue?vue&type=template&id=e6a8650e"
import script from "./Convocatorias.vue?vue&type=script&lang=js"
export * from "./Convocatorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports